import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class TagService {
  /**
   * Base URL for tags resource
   * @type {string}
   */
  private url: string = 'tags';

  /**
   * Inject dependencies
   * @param {HttpClientService} private httpClient Service for http phonecalls
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Add a tag to a model (Create action)
   * @param  {any}          params params
   * @return {Promise<any>}        Server JSON response
   */
  create(params: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }

  /**
   * Remove a tag from a model (Delete action)
   * @param  {any}          params params
   * @return {Promise<any>}        Server JSON response
   */
  delete(params: any): Promise<any> {
    if (params.angular == '2') return this.httpClient.get(`${this.url}.json`, params);
    return this.httpClient.post(`${this.url}/remove.json`, params);
  }

  /**
   * List tags for a model
   * @param  {any}          params params
   * @return {Promise<any>}        Tag list
   */
  index(params: any): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
}
